import { useState } from "react";
import SVG from "../core/SVG";
import { useDispatch } from "react-redux";
import { AppDispatch } from "services/redux/store";
import { openForm } from "services/redux/commentForm/commentForm";

const SocialCount = ({ allowComment = true }: { allowComment?: boolean }) => {
    const [liked, setLiked] = useState(false);
    const dispatch = useDispatch<AppDispatch>();

    return (
        <div className="social-count d-flex flex-j-between flex-a-center w-full">
            <div className="likes-count p-relative">
                <div
                    className="tool-tip-parent"
                    onClick={() => setLiked(!liked)}
                >
                    <div className="social-count-tooltip momeento-p">Likes</div>
                    <SVG
                        svg={`${liked ? "red-svg heart-fill" : "heart"}`}
                        size={18}
                    />
                </div>
                <p className="momeento-p white-text">27</p>
            </div>

            <div className="comments-count p-relative">
                <div
                    className="tool-tip-parent"
                    onClick={() => allowComment && dispatch(openForm())}
                >
                    <div className="social-count-tooltip momeento-p">
                        Comments
                    </div>
                    <SVG svg="message-circle" size={18} />
                </div>
                <p className="momeento-p white-text">3</p>
            </div>

            <div className="shares-count p-relative">
                <div className="tool-tip-parent">
                    <div className="social-count-tooltip momeento-p">
                        Repost
                    </div>
                    <SVG svg="repeat" size={18} />
                </div>
                <p className="momeento-p white-text">9</p>
            </div>

            <div className="likes-count p-relative">
                <div className="tool-tip-parent">
                    <div className="social-count-tooltip momeento-p">Views</div>
                    <SVG svg="show-pswd" size={18} />
                </div>
                <p className="momeento-p white-text">30</p>
            </div>

            {/* message post to drop down */}
            <div
                className={`dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger`}
            >
                <div className="fab-wrapper is-share">
                    <div
                        className="small-fab share-fab modal-trigger cursor-pointer"
                        data-modal="share-modal"
                    >
                        {/* <i data-feather="link-2"></i> */}
                        <SVG svg="arrow-out" size={18} />
                    </div>
                </div>
                <div className="dropdown-menu" role="menu">
                    <div className="dropdown-content">
                        <a href="#" className="dropdown-item">
                            <div className="media d-flex flex-j-start flex-a-center gap-10">
                                <SVG
                                    svg="arrow-out"
                                    size={18}
                                    className="light-grey-svg"
                                />
                                <div className="media-content">
                                    <h3>Message post to friend</h3>
                                </div>
                            </div>
                        </a>

                        <a href="#" className="dropdown-item">
                            <div className="media d-flex flex-j-start flex-a-center gap-10">
                                <SVG
                                    svg="community"
                                    size={18}
                                    className="light-grey-svg"
                                />
                                <div className="media-content">
                                    <h3>Message post to community</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            {/* copy post drop down */}
            <div
                className={`dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger`}
            >
                <div className="fab-wrapper is-share">
                    <div
                        className="small-fab share-fab modal-trigger cursor-pointer"
                        data-modal="share-modal"
                    >
                        {/* <i data-feather="link-2"></i> */}
                        <SVG svg="send" size={18} />
                    </div>
                </div>
                <div className="dropdown-menu" role="menu">
                    <div className="dropdown-content">
                        <a href="#" className="dropdown-item">
                            <div className="media d-flex flex-j-start flex-a-center gap-10">
                                <SVG
                                    svg="link-2"
                                    size={18}
                                    className="light-grey-svg"
                                />
                                <div className="media-content">
                                    <h3>Copy link to Momeento</h3>
                                </div>
                            </div>
                        </a>

                        <a href="#" className="dropdown-item">
                            <div className="media d-flex flex-j-start flex-a-center gap-10">
                                <SVG
                                    svg="bookmark"
                                    size={18}
                                    className="light-grey-svg"
                                />
                                <div className="media-content">
                                    <h3>Momeento mark</h3>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialCount;
